import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import React from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import queryparse from 'tricks/string/queryparse';
import jsonParse from 'tricks/string/jsonParse.js';
import CenterContent from 'components/CenterContent';
import Landmark from 'components/Landmark';
import CopyToClipboardField from 'components/FormFields/CopyToClipboardField';
import Box from 'components/Box';
import Logo from 'components/Logo';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import AlertRenderer from '../../shared/alertRenderer';
import config from 'utils/config';
import { pxToRem } from 'utils/ui';
function Unauthorised() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var showDetails = true;
  if (!location.hash) showDetails = false;
  var _queryparse = queryparse(location.hash),
    errorObject = _queryparse.errorObject;
  var _ref = jsonParse(errorObject) || {},
    error = _ref.error;
  if (!error) showDetails = false;
  var errorDetails = '';
  if (!(error !== null && error !== void 0 && error.details) && !(error !== null && error !== void 0 && error.message)) {
    errorDetails = JSON.stringify(error, null, 2);
  } else if (error !== null && error !== void 0 && error.message) {
    var _error$message;
    errorDetails = (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.includes('SAML assertion expired') ? errorDetails.concat('reason: SAML expired') : errorDetails.concat("reason: ".concat(error.message));
  }
  if (error !== null && error !== void 0 && error.details) {
    var details = typeof error.details === 'string' ? error.details : JSON.stringify(error.details, null, 2);
    errorDetails = errorDetails.concat(' ', "details: ".concat(details));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CenterContent, {
    fillParent: true,
    contentWidth: 440
  }, /*#__PURE__*/React.createElement(Card, {
    p: "m"
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    mt: "s",
    mb: "xs"
  }, /*#__PURE__*/React.createElement(Box, {
    style: {
      height: pxToRem(50)
    }
  }, /*#__PURE__*/React.createElement(Logo, {
    alt: config.orgTitle || t('hub_title')
  }))), /*#__PURE__*/React.createElement(Landmark, {
    title: t('error_unauthorised')
  }, /*#__PURE__*/React.createElement(Stack, {
    mt: "s",
    spacing: "m"
  }, t('error_account_cannot_be_authenticated', {
    hubName: config.pageTitle
  }), showDetails && /*#__PURE__*/React.createElement(CopyToClipboardField, {
    label: t('form_error_details_colon'),
    value: errorDetails.trim(),
    horizontal: true
  }))))), /*#__PURE__*/React.createElement(AlertRenderer, null));
}
export default Unauthorised;